/*
 * Page layout presets (verstka) — typographic styles for an open book page.
 * 3 variants:
 *   heading  — вопрос крупно, ответ обычным текстом
 *   body     — вопрос мелко, ответ крупный
 *   balanced — вопрос и ответ одного размера, блок сверху
 */

export type PagePreset = 'heading' | 'body' | 'balanced';

export interface PageDefinition {
  id: PagePreset;
  name: string;
  description: string;
}

export const PAGE_PRESETS: PageDefinition[] = [
  {
    id: 'heading',
    name: 'Крупный вопрос',
    description: 'Вопрос крупно, ответ обычным текстом',
  },
  {
    id: 'body',
    name: 'Крупный ответ',
    description: 'Вопрос мелко, ответ крупный',
  },
  {
    id: 'balanced',
    name: 'Один размер',
    description: 'Вопрос и ответ одного размера',
  },
];

export const DEFAULT_PAGE_PRESET: PagePreset = 'heading';

export const pagePresetById = (id: string | null | undefined): PageDefinition => {
  return PAGE_PRESETS.find((p) => p.id === id) ?? PAGE_PRESETS[0];
};
